(function () {
  if (window.__horizonDiscountBadgeInit) return;
  window.__horizonDiscountBadgeInit = true;

  function getMoneyFormat() {
    // Prefer Shopify's money formats if available
    if (window.Shopify && Shopify.currency && Shopify.currency.active && Shopify.money_with_currency_format) {
      return Shopify.money_with_currency_format;
    }
    if (window.Shopify && Shopify.money_format) return Shopify.money_format;
    return "${{amount}}";
  }

  function formatMoney(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return "";
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(n, getMoneyFormat());
    }
    // Fallback (basic)
    return (n / 100).toFixed(2);
  }

  function parseMoney(text) {
    if (!text) return NaN;
    var cleaned = text.replace(/[^0-9.,]/g, '');
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) cleaned = cleaned.replace(/,/g, '');
    else cleaned = cleaned.replace(',', '.');
    return parseFloat(cleaned);
  }

  function updateBadge(rootEl) {
    if (!rootEl) return;

    var compareEl = rootEl.querySelector('.compare-at-price');
    var priceEl = rootEl.querySelector('.price');
    var badgeEl = rootEl.querySelector('.discount-badge');

    if (!priceEl || !badgeEl) return;

    if (!compareEl || compareEl.style.display === 'none') {
      badgeEl.classList.remove('is-active');
      badgeEl.textContent = '';
      return;
    }

    var comparePrice = parseMoney(compareEl.textContent);
    var price = parseMoney(priceEl.textContent);

    if (isNaN(comparePrice) || isNaN(price) || comparePrice <= price) {
      badgeEl.classList.remove('is-active');
      badgeEl.textContent = '';
      return;
    }

    var discountPercent = Math.round(((comparePrice - price) / comparePrice) * 100);
    badgeEl.textContent = discountPercent + '% OFF';
    badgeEl.classList.add('is-active');
  }

  var rafMap = new WeakMap();
  function schedule(rootEl) {
    if (!rootEl) return;
    var old = rafMap.get(rootEl);
    if (old) cancelAnimationFrame(old);

    var id = requestAnimationFrame(function () {
      updateBadge(rootEl);
      rafMap.delete(rootEl);
    });

    rafMap.set(rootEl, id);
  }

  var observed = new WeakSet();
  function observeRoot(rootEl) {
    if (!rootEl || observed.has(rootEl)) return;
    observed.add(rootEl);

    schedule(rootEl);

    var mo = new MutationObserver(function () {
      schedule(rootEl);
    });

    mo.observe(rootEl, { childList: true, subtree: true, characterData: true });
  }

  function initAll() {
    document.querySelectorAll('[data-discount-badge-root]').forEach(observeRoot);
  }

  // Horizon: price blocks can be replaced
  var docObserver = new MutationObserver(function () { initAll(); });

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
    docObserver.observe(document.documentElement, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', initAll);

  // ✅ Variant change: update price + compare text, then badge will recalc
  document.addEventListener('variant:change', function (e) {
    var variant = e && e.detail ? (e.detail.variant || e.detail) : null;
    if (!variant) {
      initAll();
      return;
    }

    var target = e.target || document;
    var root = target.closest ? target.closest('[data-discount-badge-root]') : null;

    // If we can't locate exact root, update all on the page
    var roots = root ? [root] : Array.from(document.querySelectorAll('[data-discount-badge-root]'));

    roots.forEach(function (r) {
      var priceEl = r.querySelector('.price-ui__current');
      var compareEl = r.querySelector('.price-ui__compare');

      if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.setAttribute('data-price-cents', variant.price);
      }

      if (compareEl) {
        var ca = variant.compare_at_price || 0;
        if (ca && ca > variant.price) {
          compareEl.textContent = formatMoney(ca);
          compareEl.style.display = '';
          compareEl.setAttribute('data-compare-cents', ca);
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
          compareEl.setAttribute('data-compare-cents', 0);
        }
      }

      schedule(r);
    });
  });
}) 
// })(); TURNED OFF - price tags discounts
  

// CUSTOM TABS FOR PRODUCT PAGE
document.addEventListener("DOMContentLoaded", function() {

  const allHeadings = document.querySelectorAll(".tab-heading-boss");
  const allContents = document.querySelectorAll(".tab-text-boss");

  if (!allHeadings.length || !allContents.length) return;

  let validTabs = [];

  allHeadings.forEach((heading, index) => {
    const content = allContents[index];

    // If no matching content OR empty
    if (!content || !content.textContent.trim()) {
      heading.style.display = "none";
      if (content) content.style.display = "none";
    } else {
      validTabs.push({ heading, content });
    }
  });

  // Remove active classes from all
  allHeadings.forEach(h => h.classList.remove("active-tab"));
  allContents.forEach(c => c.classList.remove("active-content"));

  // Activate first valid tab
  if (validTabs.length > 0) {
    validTabs[0].heading.classList.add("active-tab");
    validTabs[0].content.classList.add("active-content");
  }

  // Click logic
  validTabs.forEach(tab => {
    tab.heading.addEventListener("click", function() {

      validTabs.forEach(t => {
        t.heading.classList.remove("active-tab");
        t.content.classList.remove("active-content");
      });

      tab.heading.classList.add("active-tab");
      tab.content.classList.add("active-content");

    });
  });

});
// CUSTOM TABS FOR PRODUCT PAGE END


